import { action, createRequestTypes } from "../../actions";

export const PROTOCOLS = createRequestTypes("PROTOCOLS");
export const AGREEMENTS = createRequestTypes("AGREEMENTS");
export const AGREEMENT_FILES = createRequestTypes("AGREEMENT_FILES");

export const loadProtocols = {
  request: () => action(PROTOCOLS.REQUEST, { }),
  success: response => action(PROTOCOLS.SUCCESS, { response }),
  failure: error => action(PROTOCOLS.FAILURE, error),
};

export const loadAgreements = {
  request: () => action(AGREEMENTS.REQUEST, { }),
  success: response => action(AGREEMENTS.SUCCESS, { response }),
  failure: error => action(AGREEMENTS.FAILURE, error),
};

export const loadAgreementFiles = {
  request: (file) => action(AGREEMENT_FILES.REQUEST, { file }),
  success: response => action(AGREEMENT_FILES.SUCCESS, { response }),
  failure: error => action(AGREEMENT_FILES.FAILURE, error),
};
